export default __webpack_public_path__ + "static/media/gallery - story - babbitty (1)_00.59826047.jpg";